import React, { useEffect, useState } from "react";

import { Row, Col, Card, CardBody, Button, Modal, ModalHeader, ModalBody, Spinner, Pagination, PaginationItem, PaginationLink } from "reactstrap";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import FormLayouts from "pages/Forms/FormLayouts";
import AddEditForm from "pages/Forms/AddEditForm";
import useUserlist from "./useUserlist";
import useDelete from "./useDelete";
import useUpdateUserStatus from "./useUpdateUserStatus";
import useListOrg from "pages/Dboard/useListOrg";
import { FaEdit } from "react-icons/fa";
import { FaTrashAlt } from "react-icons/fa";
import ConfirmModal from "./ConfirmModal";

const ResponsiveTables = () => {
  document.title = "Title Appraiser | List of Users";
  // getting current user role
  const currentUser =  JSON.parse(localStorage.getItem("userData"));
  console.log(currentUser)

  const[companies,setCompanies]=useState([]);

  // getting data from local storage
      useEffect(()=>{
          const cachedData = localStorage.getItem('appInitData')
  
          if (cachedData){
              const parsedData = JSON.parse(cachedData);
              setCompanies(parsedData.organization || [])
          }
          
      },[])

  // pagination
  const[currentPage,setCurrentPage]=useState(1);
  const pageSize = 10;
  
    // for search
    const[searchTerm, setSearchTerm]=useState('');
    // for organization filter
    const[orgFilter,setOrgFilter] = useState('')

  // hook for getting user data
  const{isPending,isError,error,data} = useUserlist(currentPage,pageSize,searchTerm,orgFilter);
  // hook for updating user status
  const{isUpdating, isUpdated, updateUserStatus} = useUpdateUserStatus();

  const users = data?.results || []
  const totalCount = data?.count || 0;
  const totalPages = Math.ceil(totalCount/pageSize);

  console.log("users on res table:",users)
  // hook for deleting user
  const{isDeleting, isDeleted, deleteUser}=useDelete()

  const[userToDelete,setUserToDelete] = useState(null)

  const openDeleteConfirm = (user) => setUserToDelete(user)
  const closeDeleteConfirm = () => setUserToDelete(null)

  const handleConfirmDelete = () => {
    deleteUser(userToDelete, {
      onSuccess: () => {
        closeDeleteConfirm()
      }
    })
  }

  // Style object for the sticky table headers
  const stickyHeaderStyle = {
    position: "sticky",
    top: 0,
    backgroundColor: "white",
    zIndex: 1, // Ensures header is above the scrolling content
  };

  // for modal
  const[isOpen,setIsOpen] = useState(false);
  // state to track whether its add or edit
  const[isEditMode,setIsEditMode]=useState(false)
  // stores user data for editing
  const[selectedUser,setSelectedUser]=useState(null)
  // org list
  const{isPending: isLoading,isError: isFailed, error:erros, data:orgList}=useListOrg();
  // orgs for mapping
  const orgs = orgList?.results || []

  const AddModal=()=>{
    setIsEditMode(false)
    setSelectedUser(null)
    setIsOpen(true)
  }

  const EditModal=(user)=>{
    setIsEditMode(true)
    setSelectedUser(user)
    setIsOpen(true)
  }

  const closeModal=()=>{
    setIsEditMode(false)
    setSelectedUser(null)
    setIsOpen(false)
  }

  // for status change
  const handleStatusChange=(newStatus, userId)=>{
    const updatedStatus={
      "userId":userId,
      "newStatus":newStatus
    }

    updateUserStatus(updatedStatus)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Row className="mb-4 align-items-center">
            <Col style={{ paddingLeft: "32px" }}>
              <h2 style={{ fontFamily: "unset" }}>List of Users</h2>
            </Col>
            <Col>
                {/* search */}
                    <input
                        type="text" 
                        className="form-control"
                        placeholder="Search by Username, Email"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
            </Col>
            <Col>
              {currentUser?.user?.role === '00000000-0000-0000-0000-000000000001' ?
                <select
                className="form-select"
                value={orgFilter || ""}
                style={{ width: '200px' }}
                onChange={(e)=> setOrgFilter(e.target.value)}
              >
                <option value="">Filter by Org</option>
                {companies.map((org,index)=>(
                  <option key={index} value={org.org_id}>{org.name}</option>
                ))}
              </select> : ''
              }
            </Col>
            <Col className="text-end">
              <div>
                <Button onClick={AddModal} className="btn py-2" style={{ backgroundColor: "#00ADF0", color: "white", minWidth: "150px", fontWeight: "bolder" }}>
                  Add Users
                </Button>
              </div>
            </Col>
          </Row>
          {/* Modal */}
          <Modal isOpen={isOpen} size="xl" backdrop="static" keyboard={false} toggle={null} fullscreen="xl" fade scrollable centered={true}>
            <ModalHeader close={
              <button type="button" className="btn-close" onClick={closeModal}/>
            }>
              {isEditMode ? "Edit User Details here" : "Add User Details here"}
            </ModalHeader>
            <ModalBody>
              <AddEditForm 
                isEditMode={isEditMode}
                userData={selectedUser}
                onClose={closeModal}
              />
            </ModalBody>
          </Modal>
          {/* next row */}
          <Row>
            <Col>
              <Card>
                <CardBody>
                  <div className="table-rep-plugin">
                    {/* This div is the scroll container */}
                    <div
                      className="table-responsive mb-0"
                      style={{ maxHeight: "400px",minHeight:"340px", overflowY: "auto" }}
                    >
                      <Table className="table table-striped table-bordered">
                        <Thead>
                          <Tr>
                            {/* Apply the sticky style to each header cell */}
                            <Th style={stickyHeaderStyle}>SL.No</Th>
                            <Th style={stickyHeaderStyle}>Username</Th>
                            <Th style={stickyHeaderStyle}>Email</Th>
                            <Th style={stickyHeaderStyle}>Organization</Th>
                            <Th style={stickyHeaderStyle}>Role</Th>
                            {/* <Th style={stickyHeaderStyle}>Status</Th> */}
                            {currentUser.user.role === "00000000-0000-0000-0000-000000000001" ? <Th style={stickyHeaderStyle}>Status</Th> : ''}
                            <Th style={stickyHeaderStyle}>Actions</Th>

                          </Tr>
                        </Thead>
                        <Tbody>
                          {isPending ? (
                            <Tr>
                              <Td colSpan="5" className="text-center">
                                <Spinner color="primary" />
                              </Td>
                            </Tr>
                          ) : (
                            Array.isArray(users) &&
                            users.filter((user)=>{
                              const term = searchTerm.toLowerCase();
                              const matchesSearch = user.first_name?.toLowerCase().includes(term) ||
                                                    user.email_id?.toLowerCase().includes(term)
                              const matchesOrg = !orgFilter || user.org === orgFilter;
                              return matchesSearch && matchesOrg;
                              
                            }) .map((user, index) => (
                              <Tr key={index}>
                                <Td>{index + 1}</Td>
                                <Td>{`${user.first_name} ${user.last_name || ''}`.trim()}</Td>
                                <Td>{user.email_id}</Td>
                                <Td>{user.org_name}</Td>
                                <Td>{user.role_name}</Td>
                                {/* <Td>
                                  <select
                                    className="form-select border-primary-subtle"
                                    value={user.status}
                                    onChange={(e)=> handleStatusChange(e.target.value, user.user_id)}

                                  >
                                    {user.status_choices?.map((status, index)=>(
                                      <option key={index} value={status.value}>{status.label}</option>
                                    ))}
                                  </select>
                                </Td> */}
                                {currentUser.user.role === "00000000-0000-0000-0000-000000000001" ? <Td>
                                  <select
                                    className="form-select border-primary-subtle"
                                    value={user.status}
                                    onChange={(e)=> handleStatusChange(e.target.value, user.user_id)}

                                  >
                                    {user.status_choices?.map((status, index)=>(
                                      <option key={index} value={status.value}>{status.label}</option>
                                    ))}
                                  </select>
                                </Td> : ''}
                                <Td>
                                  <div style={{ display: "flex", flexDirection: "row", gap: "0.5rem" }}>
                                    <Button
                                      style={{ backgroundColor: "#00ADF0", color: "white" }}
                                      size="sm"
                                      outline
                                      onClick={() => EditModal(user)}
                                      disabled={isDeleting || isPending}
                                    >
                                      <FaEdit/>
                                    </Button>
                                    <Button color="danger" outline size="sm" 
                                      onClick={()=> openDeleteConfirm(user)}
                                      disabled={isDeleting || isPending}
                                    >
                                      <FaTrashAlt/>
                                    </Button>
                                  </div>
                                </Td>
                              </Tr>
                            ))
                          )}
                        </Tbody>

                      </Table>
                      <div style={{display:"flex", flexDirection:"row", alignItems:"end", justifyContent:"end"}}>
                                <Pagination size="sm" className="justify-content-center">
                                {/* First Page */}
                                <PaginationItem disabled={currentPage === 1}>
                                    <PaginationLink
                                    first
                                    onClick={() => setCurrentPage(1)}
                                    style={{
                                        backgroundColor: '#f8f9fa',
                                        color: '#007bff',
                                        border: '1px solid #dee2e6',
                                        padding: '5px 10px',
                                        cursor: currentPage === 1 ? 'not-allowed' : 'pointer'
                                    }}
                                    />
                                </PaginationItem>

                                {/* Previous Page */}
                                <PaginationItem disabled={currentPage === 1}>
                                    <PaginationLink
                                    previous
                                    onClick={() => setCurrentPage(prev => prev - 1)}
                                    style={{
                                        backgroundColor: '#f8f9fa',
                                        color: '#007bff',
                                        border: '1px solid #dee2e6',
                                        padding: '5px 10px',
                                        cursor: currentPage === 1 ? 'not-allowed' : 'pointer'
                                    }}
                                    />
                                </PaginationItem>

                                {/* Page Numbers */}
                                {[...Array(totalPages)].map((_, index) => {
                                    const isActive = currentPage === index + 1;
                                    return (
                                    <PaginationItem key={index} active={isActive}>
                                        <PaginationLink
                                        onClick={() => setCurrentPage(index + 1)}
                                        style={{
                                            backgroundColor: isActive ? '#007bff' : '#fff',
                                            color: isActive ? '#fff' : '#007bff',
                                            border: '1px solid #dee2e6',
                                            padding: '5px 12px',
                                            margin: '0 2px',
                                            cursor: 'pointer',
                                            borderRadius: '4px',
                                            fontWeight: isActive ? 'bold' : 'normal',
                                        }}
                                        >
                                        {index + 1}
                                        </PaginationLink>
                                    </PaginationItem>
                                    );
                                })}

                                {/* Next Page */}
                                <PaginationItem disabled={currentPage === totalPages}>
                                    <PaginationLink
                                    next
                                    onClick={() => setCurrentPage(prev => prev + 1)}
                                    style={{
                                        backgroundColor: '#f8f9fa',
                                        color: '#007bff',
                                        border: '1px solid #dee2e6',
                                        padding: '5px 10px',
                                        cursor: currentPage === totalPages ? 'not-allowed' : 'pointer'
                                    }}
                                    />
                                </PaginationItem>

                                {/* Last Page */}
                                <PaginationItem disabled={currentPage === totalPages}>
                                    <PaginationLink
                                    last
                                    onClick={() => setCurrentPage(totalPages)}
                                    style={{
                                        backgroundColor: '#f8f9fa',
                                        color: '#007bff',
                                        border: '1px solid #dee2e6',
                                        padding: '5px 10px',
                                        cursor: currentPage === totalPages ? 'not-allowed' : 'pointer'
                                    }}
                                    />
                                </PaginationItem>
                            </Pagination>
                            </div>
                    </div>
                  </div>

                  <ConfirmModal
                    isOpen={!!userToDelete}
                    toggle={closeDeleteConfirm}
                    onConfirm={handleConfirmDelete}
                    title="Delete User"
                    message={`Are you sure you want to delete ${userToDelete?.name || userToDelete?.email || 'this user'}? This action cannot be undone.`}
                    isLoading={isDeleting}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
          
        </div>
      </div>
    </React.Fragment>
  );
};

export default ResponsiveTables;